/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PlanningGetByIdV2 } from '../models/planning-get-by-id-v-2';
import { planningsControllerCreatePlanning } from '../fn/plannings-controller/plannings-controller-create-planning';
import { PlanningsControllerCreatePlanning$Params } from '../fn/plannings-controller/plannings-controller-create-planning';
import { planningsControllerDeletePlanning } from '../fn/plannings-controller/plannings-controller-delete-planning';
import { PlanningsControllerDeletePlanning$Params } from '../fn/plannings-controller/plannings-controller-delete-planning';
import { planningsControllerGetPlanning } from '../fn/plannings-controller/plannings-controller-get-planning';
import { PlanningsControllerGetPlanning$Params } from '../fn/plannings-controller/plannings-controller-get-planning';
import { planningsControllerPatchPlanning } from '../fn/plannings-controller/plannings-controller-patch-planning';
import { PlanningsControllerPatchPlanning$Params } from '../fn/plannings-controller/plannings-controller-patch-planning';


/**
 * API resource for plannings manipulation.
 */
@Injectable({ providedIn: 'root' })
export class PlanningsControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `planningsControllerCreatePlanning()` */
  static readonly PlanningsControllerCreatePlanningPath = '/planning-projects/v2-preview/plannings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningsControllerCreatePlanning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningsControllerCreatePlanning$Response(params?: PlanningsControllerCreatePlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanningGetByIdV2>> {
    return planningsControllerCreatePlanning(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `planningsControllerCreatePlanning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningsControllerCreatePlanning(params?: PlanningsControllerCreatePlanning$Params, context?: HttpContext): Observable<PlanningGetByIdV2> {
    return this.planningsControllerCreatePlanning$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanningGetByIdV2>): PlanningGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `planningsControllerGetPlanning()` */
  static readonly PlanningsControllerGetPlanningPath = '/planning-projects/v2-preview/plannings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningsControllerGetPlanning()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningsControllerGetPlanning$Response(params: PlanningsControllerGetPlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanningGetByIdV2>> {
    return planningsControllerGetPlanning(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `planningsControllerGetPlanning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningsControllerGetPlanning(params: PlanningsControllerGetPlanning$Params, context?: HttpContext): Observable<PlanningGetByIdV2> {
    return this.planningsControllerGetPlanning$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanningGetByIdV2>): PlanningGetByIdV2 => r.body)
    );
  }

  /** Path part for operation `planningsControllerDeletePlanning()` */
  static readonly PlanningsControllerDeletePlanningPath = '/planning-projects/v2-preview/plannings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningsControllerDeletePlanning()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningsControllerDeletePlanning$Response(params: PlanningsControllerDeletePlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return planningsControllerDeletePlanning(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `planningsControllerDeletePlanning$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  planningsControllerDeletePlanning(params: PlanningsControllerDeletePlanning$Params, context?: HttpContext): Observable<void> {
    return this.planningsControllerDeletePlanning$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `planningsControllerPatchPlanning()` */
  static readonly PlanningsControllerPatchPlanningPath = '/planning-projects/v2-preview/plannings/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `planningsControllerPatchPlanning()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningsControllerPatchPlanning$Response(params: PlanningsControllerPatchPlanning$Params, context?: HttpContext): Observable<StrictHttpResponse<PlanningGetByIdV2>> {
    return planningsControllerPatchPlanning(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `planningsControllerPatchPlanning$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  planningsControllerPatchPlanning(params: PlanningsControllerPatchPlanning$Params, context?: HttpContext): Observable<PlanningGetByIdV2> {
    return this.planningsControllerPatchPlanning$Response(params, context).pipe(
      map((r: StrictHttpResponse<PlanningGetByIdV2>): PlanningGetByIdV2 => r.body)
    );
  }

}
